export function formatPrice(product) {
  if (product.price == null) return null;
  const fmt = (v) => v.toFixed(2).replace(".", ",");
  let out = `€ ${fmt(product.price)}`;
  if (product.price_max != null) out = `€ ${fmt(product.price)} – ${fmt(product.price_max)}`;
  return out;
}

export const VENUE_IMAGE = "/images/venue.webp";

export const VENUE_BG = "/images/venue-bg.webp";

export const RR_LOGO = "/rr-logo.png";

export const RECENSIO_LOGO = "/recensio-logo.png";
